import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import type { ClientStatistic } from '../../common/types/statistics/fbStatistics';

type Props = {
  clientStatistics: ClientStatistic;
};

function TimeBetweenDates({ clientStatistics }: Props) {
  const { timesBetweenDates } = clientStatistics;

  const data = Object.keys(timesBetweenDates).map((time) => {
    const numberOfTimes = timesBetweenDates[time];
    const label = numberOfTimes === 1 ? 'Termin' : 'Termine';
    return {
      title: `${time} Tage`,
      label: `${label}`,
      numberOfTimes: numberOfTimes,
    };
  });

  return (
    <Stack direction='column'>
      <Typography fontWeight='bold'>Zeit Erstkontakt bis Termin</Typography>
      {data.map((time) => (
        <Typography key={time.title}>
          {time.title}: {time.numberOfTimes} {time.label}
        </Typography>
      ))}
    </Stack>
  );
}

export default TimeBetweenDates;
